import React from "react";
import ProtectedRoutes from "../../routes/ProtectedRoutes";

const AuthSecuredComponent = (WrappedComponent) => {
  return (props) => (
    <ProtectedRoutes>
      <WrappedComponent {...props} />
    </ProtectedRoutes>
  );
};

export default AuthSecuredComponent;
